import { render, staticRenderFns } from "./toolEdit.vue?vue&type=template&id=480d153e&scoped=true"
import script from "./toolEdit.vue?vue&type=script&lang=js"
export * from "./toolEdit.vue?vue&type=script&lang=js"
import style0 from "./toolEdit.vue?vue&type=style&index=0&id=480d153e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480d153e",
  null
  
)

export default component.exports